<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HDK7Of/tc-custom/9781597142793.jpg?1726871296848" alt="This image is the cover for the book Making Home from War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Making Home from War
      </h1>
      <p class="bookDescription body article font2">
        <b>The sequel to the award-winning <i>From Our Side of the Fence</i>—personal stories of life after the WWII internment camps from twelve Japanese Americans.</b><br/>  <br/> Many books have chronicled the experience of Japanese Americans in the early days of World War II, when over 120,000 persons of Japanese ancestry, two-thirds of whom were American citizens, were taken from their homes along the West Coast and imprisoned in concentration camps. When they were finally allowed to leave, a new challenge faced them—how do you resume a life so interrupted?<br/>  <br/> Written by twelve Japanese American elders who gathered regularly at the Japanese Cultural and Community Center of Northern California, <i>Making Home from War </i>is a collection of stories about their exodus from concentration camps into a world that in a few short years had drastically changed. In order to survive, they found the resilience they needed in the form of community and gathered reserves of strength from family and friends. Through a spectrum of conflicting and rich emotions, <i>Making Home from War</i> demonstrates the depth of human resolve and faith during a time of devastating upheaval.<br/>  <br/> “I remember my release from Manzanar as scary and intense, but until now so little has been said about this aspect of the internment experience. This is an important book, its stories ground-breaking and memorable.”—Jeanne Wakatsuki Houston, author of <i>Farewell to Manzanar</i><br/>  <br/> “A deeply moving accounting of life after imprisonment, its lingering stigma, and the true meaning of freedom.”—Dr. Satsuki Ina, producer of <i>Children of the Camps</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brian Komei Dempster
      </h2>
      
      <p class="authorDescription body article">Brian Komei Dempster is a Sansei (third-generation Japanese American). He received BAs in American ethnic studies and English from the University of Washington and an MFA in creative writing from the University of Michigan. His poems have been published in various journals and anthologies. Dempster is the editor of From Our Side of the Fence: Growing Up in America's Concentration Camps, which received a 2007 Nisei Voices Award from the National Japanese American Historical Society. His debut book of poems, Topaz, is forthcoming from Four Way Books in fall 2013. He is a professor of rhetoric and language and a faculty member of Asian Pacific American studies at the University of San Francisco. Currently, he divides his time between teaching and serving as Director of Administration for the master of arts program in Asia Pacific studies.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Heyday, Berkeley
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6a63deaf